export default "__VITE_ASSET__B$DSOOri__"